/* Back-in-stock alerts – all Salon Premium stores
 * Handles every [data-stock-alert-toggle] button on the page:
 *   - product page block   (snippets/stock-alert.liquid)
 *   - small variant buttons (snippets/stock-alert-button.liquid, or the same markup built in JS)
 * Logged-in customers: one tap. Retail guests: tap -> email field. B2B guests: go to login.
 */
(function () {
  'use strict';
  var cfg = window.StockAlertConfig;
  if (!cfg || window.__stockAlertInit) return;
  window.__stockAlertInit = true;
  var t = cfg.t;
  var isGuest = !cfg.loggedIn;
  var guestForm = isGuest && cfg.mode !== 'b2b';
  var serverSubs = new Set();
  var ready = false;
  var LS_KEY = 'stockAlert:v1';

  /* ---------- guest memory (this browser only) ---------- */

  function readLocal() {
    try {
      var d = JSON.parse(localStorage.getItem(LS_KEY) || '{}');
      d.variants = d.variants || {};
      var now = Date.now();
      Object.keys(d.variants).forEach(function (id) { if (d.variants[id] < now) delete d.variants[id]; });
      return d;
    } catch (e) { return { variants: {} }; }
  }
  function writeLocal(d) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(d)); } catch (e) { /* storage off */ }
  }
  var local = readLocal();

  function isOn(id) {
    return isGuest ? !!local.variants[id] : serverSubs.has(id);
  }
  function markOn(id, on, email) {
    if (isGuest) {
      if (on) local.variants[id] = Date.now() + Number(cfg.days || 60) * 86400000;
      else delete local.variants[id];
      if (email) local.email = email;
      writeLocal(local);
    } else if (on) serverSubs.add(id);
    else serverSubs.delete(id);
  }

  /* ---------- server ---------- */

  function api(path, body) {
    var opts = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(cfg.proxyPath + path, opts).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        data.httpStatus = res.status;
        return data;
      });
    });
  }

  function loadSubscriptions() {
    if (isGuest) { ready = true; renderAll(); return; }
    api('/subscriptions')
      .then(function (d) { (d.variants || []).forEach(function (id) { serverSubs.add(String(id)); }); })
      .catch(function () {})
      .then(function () { ready = true; renderAll(); });
  }

  /* ---------- helpers ---------- */

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fill(s, email) {
    return String(s).replace('{days}', cfg.days || 60).replace('{email}', email || '');
  }
  function validEmail(e) {
    return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(e) && e.length <= 254;
  }

  /* ---------- product page: follow the selected variant ---------- */

  function productBlocks() {
    return document.querySelectorAll('[data-stock-alert-product]');
  }

  function variantMap(block) {
    if (!block._saMap) {
      try { block._saMap = JSON.parse(block.querySelector('[data-stock-alert-variants]').textContent); }
      catch (e) { block._saMap = {}; }
    }
    return block._saMap;
  }

  function currentVariantId(block) {
    var section = block.closest('.shopify-section') || document;
    var form = block.closest('form[action*="/cart/add"]') || section.querySelector('form[action*="/cart/add"]');
    var input = form && form.querySelector('[name="id"]');
    var fromUrl = new URLSearchParams(location.search).get('variant');
    return String((input && input.value) || fromUrl || block.dataset.defaultVariant || '');
  }

  function syncProductBlock(block, forcedId) {
    var id = String(forcedId || currentVariantId(block));
    var btn = block.querySelector('[data-stock-alert-toggle]');
    if (!btn || !id) return;
    block.hidden = variantMap(block)[id] !== false;
    if (btn.dataset.variantId !== id) {
      closeForm(btn);
      btn.dataset.variantId = id;
      block._saMessage = false;
    }
    renderButton(btn);
  }

  function syncAllProductBlocks(forcedId) {
    productBlocks().forEach(function (b) { syncProductBlock(b, forcedId); });
  }

  /* ---------- rendering ---------- */

  function setNote(block, html) {
    var note = block && block.querySelector('[data-stock-alert-note]');
    if (note) note.innerHTML = html;
  }

  function renderButton(btn) {
    var id = btn.dataset.variantId;
    var block = btn.closest('[data-stock-alert-product]');

    if (isGuest && !guestForm) {
      btn.textContent = t.login;
      btn.classList.remove('is-subscribed');
      btn.setAttribute('aria-pressed', 'false');
      btn.removeAttribute('title');
      return;
    }

    var on = isOn(id);
    btn.textContent = on ? t.subscribed : t.notify;
    btn.classList.toggle('is-subscribed', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (on) btn.title = t.cancel; else btn.removeAttribute('title');
    btn.disabled = !ready;
    if (guestForm) btn.setAttribute('aria-expanded', btn._saForm ? 'true' : 'false');

    if (block && !block._saMessage) {
      var text = isGuest ? fill(t.noteGuest, local.email) : fill(t.note);
      setNote(block, on
        ? escapeHtml(text) + ' <button type="button" class="stock-alert__cancel" data-stock-alert-cancel>' + escapeHtml(t.cancel) + '</button>'
        : '');
    }
  }

  function renderVariant(id) {
    document.querySelectorAll('[data-stock-alert-toggle][data-variant-id="' + id + '"]').forEach(renderButton);
  }

  function renderAll() {
    syncAllProductBlocks();
    document.querySelectorAll('[data-stock-alert-toggle]').forEach(function (btn) {
      if (!btn.closest('[data-stock-alert-product]')) renderButton(btn);
    });
  }

  function flash(btn, message) {
    var block = btn.closest('[data-stock-alert-product]');
    if (btn._saForm) { formMessage(btn._saForm, message, true); return; }
    if (block) {
      block._saMessage = true;
      setNote(block, escapeHtml(message));
      setTimeout(function () { block._saMessage = false; renderButton(btn); }, 5000);
    } else {
      btn.textContent = message;
      setTimeout(function () { renderButton(btn); }, 3500);
    }
  }

  /* ---------- guest email form ---------- */

  var formCount = 0;

  function privacyHtml() {
    var html = escapeHtml(t.privacy);
    if (cfg.privacyUrl) {
      html += ' <a href="' + escapeHtml(cfg.privacyUrl) + '" target="_blank" rel="noopener">' + escapeHtml(t.privacyLink) + '</a>';
    }
    return html;
  }

  function formMessage(form, text, isError) {
    var msg = form.querySelector('.stock-alert-form__msg');
    msg.classList.toggle('is-error', !!isError);
    msg.innerHTML = isError ? escapeHtml(text) : privacyHtml();
  }

  function openForm(btn) {
    if (btn._saForm) { btn._saForm.querySelector('input[type="email"]').focus(); return; }
    formCount += 1;
    var inputId = 'stock-alert-email-' + formCount;
    // A <div>, not a <form>: the block often sits inside the theme's add-to-cart form.
    var form = document.createElement('div');
    form.className = 'stock-alert-form';
    form.setAttribute('role', 'group');
    form.innerHTML =
      '<label class="stock-alert-form__label" for="' + inputId + '">' + escapeHtml(t.emailLabel) + '</label>' +
      '<div class="stock-alert-form__row">' +
        '<input class="stock-alert-form__input" type="email" id="' + inputId + '" name="email" autocomplete="email" inputmode="email" required>' +
        '<button type="button" data-stock-alert-submit class="stock-alert-form__submit ' + escapeHtml(btn.className.replace(/stock-alert__\S+|is-subscribed/g, '')) + '">' + escapeHtml(t.submit) + '</button>' +
      '</div>' +
      '<div class="stock-alert-form__hp" aria-hidden="true"><input type="text" name="website" tabindex="-1" autocomplete="off"></div>' +
      '<p class="stock-alert-form__msg" aria-live="polite"></p>';
    formMessage(form, '', false);

    var input = form.querySelector('input[type="email"]');
    if (local.email) input.value = local.email;
    form._openedAt = Date.now();
    form._btn = btn;

    var block = btn.closest('[data-stock-alert-product]');
    var slot = block && block.querySelector('[data-stock-alert-form-slot]');
    if (slot) slot.appendChild(form); else btn.insertAdjacentElement('afterend', form);

    btn._saForm = form;
    btn.setAttribute('aria-expanded', 'true');
    input.focus();
  }

  function closeForm(btn) {
    if (btn._saForm) {
      btn._saForm.remove();
      btn._saForm = null;
      btn.setAttribute('aria-expanded', 'false');
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var form = e.target.closest && e.target.closest('.stock-alert-form');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    submitForm(form);
  }, true);

  function submitForm(form) {
    var btn = form._btn;
    var email = form.querySelector('input[type="email"]').value.trim().toLowerCase();
    if (!validEmail(email)) { formMessage(form, t.badEmail, true); return; }
    if (form.getAttribute('aria-busy') === 'true') return;
    form.setAttribute('aria-busy', 'true');

    var id = btn.dataset.variantId;
    api('/subscribe', {
      variant_id: id,
      locale: cfg.locale,
      email: email,
      elapsed_ms: Date.now() - form._openedAt,
      website: form.querySelector('[name="website"]').value
    })
      .then(function (d) {
        if (d.ok && d.status === 'subscribed') {
          markOn(id, true, email);
          closeForm(btn);
          renderVariant(id);
          announce(id, true);
        } else if (d.ok && d.status === 'in_stock') formMessage(form, t.inStock, true);
        else if (d.error === 'bad_email') formMessage(form, t.badEmail, true);
        else if (d.error === 'limit') formMessage(form, t.limit, true);
        else formMessage(form, t.error, true);
      })
      .catch(function () { formMessage(form, t.error, true); })
      .then(function () { form.removeAttribute('aria-busy'); });
  }

  /* ---------- actions ---------- */

  function goToLogin() {
    var back = location.pathname + location.search;
    try { sessionStorage.setItem('sp_return_to', back); } catch (e) { /* storage off */ }
    location.href = cfg.loginUrl + '?return_url=' + encodeURIComponent(back);
  }

  function announce(id, on) {
    document.dispatchEvent(new CustomEvent('stock-alert:change', { detail: { variantId: id, subscribed: on } }));
  }

  function toggle(btn) {
    var id = btn.dataset.variantId;
    if (!id || btn.getAttribute('aria-busy') === 'true') return;
    if (isGuest && !guestForm) { goToLogin(); return; }

    var wasOn = isOn(id);
    if (guestForm && !wasOn) {
      if (btn._saForm) closeForm(btn); else openForm(btn);
      return;
    }

    btn.setAttribute('aria-busy', 'true');
    var body = { variant_id: id, locale: cfg.locale };
    if (isGuest) body.email = local.email;

    api(wasOn ? '/unsubscribe' : '/subscribe', body)
      .then(function (d) {
        if (d.httpStatus === 401 && d.error === 'login_required') { goToLogin(); return; }
        if (d.ok && d.status === 'subscribed') markOn(id, true);
        else if (d.ok && d.status === 'cancelled') markOn(id, false);
        else if (d.ok && d.status === 'in_stock') { flash(btn, t.inStock); return; }
        else if (d.error === 'limit') { flash(btn, t.limit); return; }
        else if (isGuest && d.error === 'bad_email') { markOn(id, false); renderVariant(id); return; }
        else { flash(btn, t.error); return; }
        renderVariant(id);
        announce(id, isOn(id));
      })
      .catch(function () { flash(btn, t.error); })
      .then(function () { btn.removeAttribute('aria-busy'); });
  }

  document.addEventListener('click', function (e) {
    var submit = e.target.closest('[data-stock-alert-submit]');
    if (submit) {
      e.preventDefault();
      e.stopPropagation();
      submitForm(submit.closest('.stock-alert-form'));
      return;
    }
    var cancel = e.target.closest('[data-stock-alert-cancel]');
    if (cancel) {
      var block = cancel.closest('[data-stock-alert-product]');
      var b = block && block.querySelector('[data-stock-alert-toggle]');
      if (b) toggle(b);
      return;
    }
    var btn = e.target.closest('[data-stock-alert-toggle]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      toggle(btn);
    }
  });

  /* ---------- variant changes ---------- */

  document.addEventListener('change', function (e) {
    if (e.target.closest('.stock-alert-form')) return;
    if (e.target.closest('form[action*="/cart/add"], variant-selects, variant-radios, [data-product-form]')) {
      setTimeout(syncAllProductBlocks, 60);
    }
  });

  ['variant:change', 'variant:changed', 'variantChange', 'on:variant:change', 'product:variant-change']
    .forEach(function (name) {
      document.addEventListener(name, function (e) {
        var v = e.detail && (e.detail.variant || e.detail.selectedVariant || e.detail);
        var id = v && (v.id || v.variantId);
        setTimeout(function () { syncAllProductBlocks(id ? String(id) : undefined); }, 30);
      });
    });

  var lastIds = '';
  setInterval(function () {
    var blocks = productBlocks();
    if (!blocks.length) return;
    var ids = Array.prototype.map.call(blocks, currentVariantId).join(',');
    if (ids !== lastIds) { lastIds = ids; syncAllProductBlocks(); }
  }, 500);

  var queued = false;
  new MutationObserver(function (mutations) {
    if (queued) return;
    var relevant = mutations.some(function (m) {
      return Array.prototype.some.call(m.addedNodes, function (n) {
        return n.nodeType === 1 && (n.matches('[data-stock-alert-toggle], [data-stock-alert-product]') ||
          !!n.querySelector('[data-stock-alert-toggle]'));
      });
    });
    if (!relevant) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; renderAll(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { renderAll(); loadSubscriptions(); });
  } else {
    renderAll();
    loadSubscriptions();
  }
})();